import ParameterValidator from '@mvps-genesis/parameter-validator';

/*
 *--------------------------------------------------------------------------
 * Short Description
 *--------------------------------------------------------------------------
 */

export default class ShortDesc {

	/**
	 * Parameter Validator object
	 *
	 * @var	@mvps-genesis/parameter-validator	ParameterValidator
	 */
	#validator;

	/**
	 * The short description element
	 *
	 * @var	Element
	 */
	element;

	/**
	 * The short description text element
	 *
	 * @var	Element
	 */
	textElement;

	/**
	 * The short description link element
	 *
	 * @var	Element
	 */
	linkElement;

	/**
	 * The short description max word count
	 *
	 * @var	Number
	 */
	maxWordCount;

	/**
	 * Element to target for scroll to functionality
	 *
	 * @var	Element
	 */
	scrollToElement;

	/**
	 * Scroll into view behavior
	 *
	 * @var	Object
	 */
	scrollIntoView;

	/**
	 * Create a new ShortDesc object
	 *
	 * @property	Element			linkElement			Element containing short description "Read More" link. Defaults to '.g-short-desc__link'.
	 * @property	Integer			maxWordCount		Max word count for short description. Defaults to 20.
	 * @property	Object			scrollIntoView		Scroll into view behavior - https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView. Defaults to {behavior: 'smooth'}.
	 * @property	Element|Boolean	scrollToElement		Element to target for scroll to functionality. Pass in a boolean value of false to disable the scroll to functionality. Defaults to '.g-product-description'.
	 * @property	Element			shortDescElement	Root container element to target for short description functionality.
	 * @property	Element			textElement			Element containing short description text. Defaults to '.g-short-desc__text'.
	 */
	constructor ({
		linkElement = '.g-short-desc__link',
		maxWordCount = 20,
		scrollIntoView = {
			behavior: 'smooth'
		},
		scrollToElement = '.g-product-description',
		shortDescElement,
		textElement = '.g-short-desc__text'
	} = {}) {

		// Create param validator
		this.#validator = new ParameterValidator(this);

		// The short description object
		this.element = this.#validator.isElement('shortDescElement', shortDescElement);
		this.textElement = this.#validator.isElement('shortDescText', textElement, {container: this.element});
		this.linkElement = this.#validator.isElement('linkElement', linkElement, {container: this.element});
		this.maxWordCount = this.#validator.isInt('maxWordCount', maxWordCount);
		this.scrollIntoView = this.#validator.isObject('scrollIntoView', scrollIntoView);
		this.scrollToElement = scrollToElement;

		if (this.scrollToElement !== false) {
			this.scrollToElement = this.#validator.isElement('scrollToElement', scrollToElement);
		}

		this.bindEvents();
		this.shortenDescription();
	}

	/**
	 * Bind the base events
	 *
	 * @return	Boolean
	 */
	bindEvents () {
		if (this.scrollToElement !== false) {
			this.scrollToProdDetails();
		}
	}

	shortenDescription () {
		const shortDescText = this.textElement.textContent.trim().split(/\s+/);

		if (shortDescText.length > this.maxWordCount) {
			const shortDescSplit = shortDescText.slice(0, this.maxWordCount);

			this.textElement.textContent = `${shortDescSplit.join(' ')}...`;

			this.linkElement.classList.remove('u-hidden');
		}
	}

	scrollToProdDetails () {
		this.linkElement.addEventListener('click', (e) => {
			e.preventDefault();

			this.scrollToElement.scrollIntoView(this.scrollIntoView);
		});
	}

}
